export default __webpack_public_path__ + "fonts/Losberger_930389944e97065c690646c4cd5f5e1d.svg";